

// Guitar Social Club - Video Database Logic

export type GSCStyle = 'SONGWRITING' | 'ROCK_BLUES' | 'POP_FUNK' | 'INDIE_ALT';

// [VideoID, Title, Part/Label, RhythmType, Tempo/BPM, Style]
const RAW_DB: [string, string, string, string, string, GSCStyle][] = [
    ["0011VSR60", "Knocking on Heaven's Door", "Intro / Refrain", "Ronde", "60", "SONGWRITING"],
    ["0011VSB60", "Knocking on Heaven's Door", "Intro / Refrain", "Blanche", "60", "SONGWRITING"],
    ["0021VSR60", "Bad Moon Rising", "Intro / Couplet", "Ronde", "60", "ROCK_BLUES"],
    ["0031VSR60", "Wicked Game", "Main", "Ronde", "60", "SONGWRITING"],
    ["0041VSR60", "Yellow Submarine", "Partie 1", "Ronde", "60", "SONGWRITING"],
    ["0051VSR60", "Come as You Are", "Couplet", "Ronde", "60", "INDIE_ALT"],
    ["0061VSR60", "Free Fallin", "Main", "Ronde", "60", "SONGWRITING"],
    ["0071VSR60", "Cream", "Intro", "Ronde", "60", "ROCK_BLUES"],
    ["0091VSR60", "Ain't No Sunshine", "Main", "Ronde", "60", "SONGWRITING"],
    ["0101VSGR60", "I Won't Back Down", "Intro", "Vrai Rythme", "60", "SONGWRITING"],
    ["0111VSR60", "Stand By Me", "Main", "Ronde", "60", "SONGWRITING"],
    ["0121VSR60", "Yellow", "Intro", "Ronde", "60", "SONGWRITING"],
    ["0141VSR60", "With or Without You", "Main", "Ronde", "60", "INDIE_ALT"],
    ["0161VSR60", "Heart of Gold", "Intro", "Ronde", "60", "SONGWRITING"],
    ["0171VSR60", "Heroes", "Intro", "Ronde", "60", "ROCK_BLUES"],
    ["0191VSB60", "Hallelujah", "Couplet", "Blanche", "60", "SONGWRITING"],
    ["0201VSR60", "Three Little Birds", "Intro", "Ronde", "60", "SONGWRITING"],
    ["0211VSR60", "What's Up?", "Main", "Ronde", "60", "SONGWRITING"],
    ["0301VSR60", "Zombie", "Intro", "Ronde", "60", "INDIE_ALT"],
    ["0311VSR60", "The Scientist", "Main", "Ronde", "60", "SONGWRITING"],
    ["0321VSB60", "Imagine", "Intro", "Blanche", "60", "SONGWRITING"],
    ["0331VSB60", "Wonderful Tonight", "Intro", "Blanche", "60", "ROCK_BLUES"],
    ["0371VSN60", "No Woman, No Cry", "Refrain", "Noire", "60", "SONGWRITING"],
    ["0381VSGR60", "Cocaine", "Intro", "Vrai Rythme", "60", "ROCK_BLUES"],
    ["0391VSN60", "Wish You Were Here", "Couplet", "Noire", "60", "SONGWRITING"],
    ["0401VSB60", "Free Bird", "Couplet", "Blanche", "60", "ROCK_BLUES"],
    ["0431VSN60", "(I Can't Get No) Satisfaction", "Main", "Noire", "60", "ROCK_BLUES"],
    ["0461VSN60", "All Along the Watchtower", "Main", "Noire", "60", "ROCK_BLUES"],
    ["0491VSGRGT", "Let It Be", "Couplet", "Vrai Rythme", "Good Tempo", "SONGWRITING"],
    ["0501VSN60", "Hey Joe", "Intro", "Noire", "60", "ROCK_BLUES"],
    ["0531VSB60", "Fortunate Son", "Intro", "Blanche", "60", "ROCK_BLUES"],
    ["0551VSGRGT", "Fade to Black", "Intro", "Vrai Rythme", "Good Tempo", "ROCK_BLUES"],
    ["0561VSGR60", "Otherside", "Intro", "Vrai Rythme", "60", "INDIE_ALT"],
    ["0631VSGRGT", "The Sound of Silence", "Main", "Vrai Rythme", "Good Tempo", "SONGWRITING"],
    ["0651VSN60", "Losing My Religion", "Intro", "Noire", "60", "INDIE_ALT"],
    ["0661VSN60", "Sweet Child O' Mine", "Intro", "Noire", "60", "ROCK_BLUES"],
    ["0751VSB60", "Kiss", "Intro", "Blanche", "60", "POP_FUNK"],
    ["0761VSRS60", "Hey Jude", "Couplet", "Rythme Simplifié", "60", "SONGWRITING"],
    ["0781VSGRGT", "Everlong", "Main", "Vrai Rythme", "Good Tempo", "INDIE_ALT"],
    ["0901VSRS60", "Hotel California", "Intro", "Rythme Simplifié", "60", "ROCK_BLUES"]
];

// TEACHER-LOCKED GRID DATABASE (Explicit measures with |)
export const SONG_GRIDS: Record<string, string[]> = {
    "Knocking on Heaven's Door": ["G", "D", "|", "Am", "|", "G", "D", "|", "C"],
    "Bad Moon Rising": ["D", "A", "G", "|", "D"],
    "Wicked Game": ["Bm", "|", "A", "|", "E", "|", "E"],
    "Yellow Submarine": ["D", "|", "A", "|", "G", "|", "D"],
    "Come as You Are": ["F#m", "|", "E"],
    "Free Fallin": ["F", "Bb", "|", "F", "C"],
    "Cream": ["D", "C", "G"],
    "Ain't No Sunshine": ["Am", "Em", "|", "G", "Am"],
    "I Won't Back Down": ["Em", "D", "G"],
    "Stand By Me": ["A", "|", "F#m", "|", "D", "E", "|", "A"],
    "Yellow": ["B", "|", "F#", "|", "E", "|", "B"],
    "With or Without You": ["D", "A", "|", "Bm", "G"],
    "Heart of Gold": ["Em", "C", "|", "D", "G"],
    "Heroes": ["D", "|", "G"],
    "Hallelujah": ["G", "Em", "|", "G", "Em", "|", "C", "D", "|", "G"],
    "Three Little Birds": ["A", "|", "D", "|", "E"],
    "What's Up?": ["A", "|", "Bm", "|", "D", "|", "A"],
    "Zombie": ["Em", "|", "C", "|", "G", "|", "D"], 
    "The Scientist": ["Dm", "Bb", "|", "F", "|", "F"],
    "Imagine": ["C", "|", "Cmaj7", "|", "F"],
    "Wonderful Tonight": ["G", "D", "|", "C", "D"],
    "No Woman, No Cry": ["C", "G", "|", "Am", "F", "|", "C", "G", "|", "C"],
    "Cocaine": ["E", "|", "D"],
    "Wish You Were Here": ["G", "Em", "|", "G", "Em", "|", "A", "Em", "|", "A", "G"],
    "Free Bird": ["G", "D", "|", "Em", "F", "|", "C", "D"],
    "(I Can't Get No) Satisfaction": ["E", "|", "A"],
    "All Along the Watchtower": ["Cm", "Bb", "|", "Ab", "Bb"],
    "Let It Be": ["C", "G", "|", "Am", "F", "|", "C", "G", "|", "F", "C"],
    "Hey Joe": ["C", "G", "|", "D", "A", "|", "E"],
    "Fortunate Son": ["G", "F", "|", "C", "G"],
    "Fade to Black": ["Bm", "A", "|", "E", "G"],
    "Otherside": ["Am", "F", "|", "C", "G"],
    "The Sound of Silence": ["Am", "G", "|", "Am", "|", "C", "F", "|", "C"],
    "Losing My Religion": ["Am", "Em", "|", "Am", "Em"],
    "Sweet Child O' Mine": ["D", "C", "|", "G", "D"],
    "Kiss": ["A", "D", "|", "E"],
    "Hey Jude": ["F", "C", "|", "C7", "F", "|", "Bb", "F", "|", "C", "F"],
    "Everlong": ["Dmaj7", "|", "Bsus2", "|", "G", "|", "Bsus2"],
    "Hotel California": ["Bm", "|", "F#", "|", "A", "|", "E", "|", "G", "|", "D", "|", "Em", "|", "F#"]
};

const ARTIST_MAP: Record<string, string> = {
    "Knocking on Heaven's Door": "Bob Dylan / GNR",
    "Bad Moon Rising": "CCR",
    "Wicked Game": "Chris Isaak",
    "Yellow Submarine": "The Beatles",
    "Come as You Are": "Nirvana",
    "Free Fallin": "Tom Petty",
    "Cream": "Prince",
    "Ain't No Sunshine": "Bill Withers",
    "I Won't Back Down": "Tom Petty",
    "Stand By Me": "Ben E. King",
    "Yellow": "Coldplay",
    "With or Without You": "U2",
    "Heart of Gold": "Neil Young",
    "Heroes": "David Bowie",
    "Hallelujah": "Jeff Buckley",
    "Three Little Birds": "Bob Marley",
    "What's Up?": "4 Non Blondes",
    "Zombie": "The Cranberries",
    "The Scientist": "Coldplay",
    "Imagine": "John Lennon",
    "Wonderful Tonight": "Eric Clapton",
    "No Woman, No Cry": "Bob Marley",
    "Cocaine": "Eric Clapton",
    "Wish You Were Here": "Pink Floyd",
    "Free Bird": "Lynyrd Skynyrd",
    "(I Can't Get No) Satisfaction": "Rolling Stones",
    "All Along the Watchtower": "Jimi Hendrix",
    "Let It Be": "The Beatles",
    "Hey Joe": "Jimi Hendrix",
    "Fortunate Son": "CCR",
    "Fade to Black": "Metallica",
    "Otherside": "Red Hot Chili Peppers",
    "The Sound of Silence": "Simon & Garfunkel",
    "Losing My Religion": "R.E.M.",
    "Sweet Child O' Mine": "Guns N' Roses",
    "Kiss": "Prince",
    "Hey Jude": "The Beatles",
    "Everlong": "Foo Fighters",
    "Hotel California": "Eagles"
};

export interface GSCVideo {
    id: string;
    title: string;
    artist: string; 
    part: string;
    rhythm: string;
    bpm: string;
    url: string;
    style: GSCStyle;
}

const parseDatabase = (): GSCVideo[] => {
    return RAW_DB.map(row => {
        const title = row[1] as string; // Axe 2: Explicitly cast to string
        const artist = ARTIST_MAP[title] || "Unknown Artist";
        return {
            id: row[0],
            title: title,
            artist: artist,
            part: row[2],
            rhythm: row[3],
            bpm: row[4],
            url: "https://guitarsocialclub.chottu.link/home",
            style: row[5]
        };
    });
};

const DATABASE = parseDatabase();

export const findSongStyle = (title: string): GSCStyle => {
    const match = DATABASE.find(v => v.title.toLowerCase() === title.toLowerCase());
    return match ? match.style : 'SONGWRITING'; // Default
};

export const findSongGrid = (query: string): string[] | null => {
    if (!query) return null;
    const normalized = query.toLowerCase().replace(/[^a-z0-9]/g, '');
    for (const [title, grid] of Object.entries(SONG_GRIDS)) {
        const normTitle = title.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (normalized.includes(normTitle) || normTitle.includes(normalized)) {
            return grid;
        }
    }
    return null;
};

const getRecommendedRhythm = (score: number): string[] => {
    if (score < 40) return ["Ronde"]; 
    if (score < 60) return ["Blanche"]; 
    if (score < 75) return ["Noire"]; 
    if (score < 88) return ["Rythme Simplifié", "Noire pointee"]; 
    return ["Vrai Rythme", "Double croche", "Good Tempo"]; 
};

export const findRelevantVideos = (songName: string, targetBpm: number, score: number): GSCVideo[] => {
    const targetRhythms = getRecommendedRhythm(score);
    let matches: GSCVideo[] = [];
    const normalizedQuery = songName ? songName.toLowerCase().replace(/[^a-z0-9]/g, '') : "";
    if (normalizedQuery.length > 2) {
        matches = DATABASE.filter(v => v.title.toLowerCase().replace(/[^a-z0-9]/g, '').includes(normalizedQuery));
        if (matches.length === 0) {
            const words = songName.split(' ');
            if (words.length > 0) {
                const firstKeyword = words[0].toLowerCase().replace(/[^a-z0-9]/g, '');
                if (firstKeyword.length > 2) {
                    matches = DATABASE.filter(v => v.title.toLowerCase().replace(/[^a-z0-9]/g, '').includes(firstKeyword));
                }
            }
        }
    }
    if (matches.length === 0) {
        matches = DATABASE.filter(v => targetRhythms.some(r => v.rhythm.includes(r)));
        matches = matches.sort(() => 0.5 - Math.random());
    }
    matches.sort((a, b) => {
        const aIsTarget = targetRhythms.some(r => a.rhythm.includes(r));
        const bIsTarget = targetRhythms.some(r => b.rhythm.includes(r));
        if (aIsTarget && !bIsTarget) return -1;
        if (!aIsTarget && bIsTarget) return 1;
        return 0;
    });
    return matches.slice(0, 4);
};